import shareModal from "src/components/ShareModal";
import { shareProposal } from "src/api/projects";
import { toast } from "react-toastify";
import i18next from "../plugins/i18nextPlugin";

export async function shareProposalWithModal(proposal) {
  const response = await shareModal({ proposalType: proposal.type });
  if (!response) {
    return;
  }
  const mail = {
    to: response.emailAdresses.join(","),
    msg: response.text
  };
  const responseShare = await shareProposal(mail, proposal.uuid);
  if (!responseShare) {
    return toast.error(i18next.t("proposal.errorShare"));
  }
  return toast.success(i18next.t("proposal.validShare"));
}



// WEBPACK FOOTER //
// ./src/helpers/shareProposalWithModal.ts